<template>
  <div :class="gridClass">
    <InfoCard v-for="(item, idx) in items" :key="idx" :item="item" />
  </div>
</template>

<script setup lang="ts">
import InfoCard from './GridItem.vue';

interface InfoItem {
  label: string;
  value: string | number;
  icon?: string;
}

defineProps<{
  items: InfoItem[];
  gridClass: string;
}>();
</script>

<style scoped>
/* Example grid style, adjust as needed */
:global(.team-grid), :global(.team-stats-grid) {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 16px;
}
</style> 